// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1370c32f","455":"45a33ba3","977":"2caed02d"}[chunkId] + ".chunk.js";
};